import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { UploadFileContactInformation } from "../model/potential-customer";
import { loadPremisesPhotos } from "src/app/state/actions/contact-information.actions";

@Injectable({
  providedIn: "root",
})
export class CustomerInformationService {
  constructor(private store: Store) {}

  saveFiles(upload: UploadFileContactInformation) {
  this.store.dispatch(loadPremisesPhotos({ uploadFileContactInformationInfo: upload }));
  }
}
